import { cn } from "@/lib/utils";

interface ChatMessageProps {
  role: "user" | "assistant";
  content: string;
}

export const ChatMessage = ({ role, content }: ChatMessageProps) => {
  const isAssistant = role === "assistant";
  
  return (
    <div className={cn(
      "flex w-full mb-3",
      isAssistant ? "justify-start" : "justify-end"
    )}>
      <div className={cn(
        "max-w-[85%] rounded-2xl px-4 py-3 text-sm leading-relaxed",
        isAssistant 
          ? "bg-muted text-foreground rounded-bl-md" 
          : "bg-primary text-primary-foreground rounded-br-md"
      )}>
        {content}
      </div>
    </div>
  );
};
